import styles from './HorizontalTabs.module.css';
import {classNames} from '../../utils';
import { Tab, TabData } from '../../atoms/tab';
import { useEffect, useRef, useState } from 'react';

interface HorizontalTabsProps {
    fullWidth?: boolean;
    active?: string | null;
    tabs: TabData[];
    onChange?: (tab: TabData) => void;
}

const HorizontalTabs = ({
    fullWidth = false,
    active = null,
    tabs,
    onChange
}: HorizontalTabsProps) => {
    const activeTabLineRef = useRef<HTMLDivElement>(null);
    const tabsRef = useRef<(HTMLDivElement | null)[]>([]);

    const [ activeTab, setActiveTab ] = useState<TabData>(tabs.find(tab => tab.value === active) || null);
    const [ hasActiveTab, setHasActiveTab ] = useState<boolean>(false);

    const handleTabClick = (tab: TabData) => {
        setActiveTab(tab);

        onChange?.(tab);
    }

    useEffect(() => {
        setActiveTab(tabs.find(tab => tab.value === active) || null);
    }, [active])

    useEffect(() => {
        setHasActiveTab(true);
    }, [activeTab]);

    return (
        <div className={styles.container}>
            <div className={classNames(styles.tabsContainer, fullWidth && styles.fullWidth)}>
                {tabs.map((tab, index) => {
                    return (
                        <Tab
                            key={index}
                            ref={(el) => (tabsRef.current[tab.value] = el)}
                            icon={tab.icon ? tab.icon : null}
                            value={tab.value}
                            label={tab.label}
                            required={tab.required ? tab.required : null}
                            active={activeTab ? activeTab.value === tab.value : false}
                            onClick={() => handleTabClick(tab)}
                        />
                    );
                })}
                {hasActiveTab && tabsRef.current[activeTab.value] &&
                    <div
                        ref={activeTabLineRef}
                        className={styles.activeTabLine}
                        style={{
                            width: tabsRef.current[activeTab.value] ? `${tabsRef.current[activeTab.value].clientWidth}px` : undefined,
                            transform: tabsRef.current[activeTab.value] ? `translateX(${tabsRef.current[activeTab.value].offsetLeft}px)` : undefined,
                        }}
                    ></div>
                }
            </div>
        </div>
    );
};

export default HorizontalTabs;
